<div class="text-large font-medium margin-bottom-2">
    <a [routerLink]="'..'">{{ 'self-serve.addYourTeam.addEmployees.addYourTeam' | translate }}</a> /
    {{ 'self-serve.addYourTeam.addEmployees.addEmployees' | translate }}
</div>

<form invalidControlScroll #form="ngForm" [class.loading]="isLoading" (ngSubmit)="onSubmit()">
    <app-segment-header [title]="'self-serve.addYourTeam.addEmployees.personalInformation'"></app-segment-header>

    <div class="responsive-grid">
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.addYourTeam.addEmployees.firstName' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="firstName"
                    #firstName="ngModel"
                    [(ngModel)]="employee.firstName"
                />
                <mat-error *ngIf="firstName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ 'self-serve.addYourTeam.addEmployees.lastName' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="lastName"
                    #lastName="ngModel"
                    [(ngModel)]="employee.lastName"
                />
                <mat-error *ngIf="lastName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
        </div>
        <mat-form-field>
            <mat-label>{{ 'self-serve.addYourTeam.addEmployees.email' | translate }}</mat-label>
            <input
                matInput
                type="text"
                name="email"
                placeholder="Eg: alex@company.com"
                #email="ngModel"
                [(ngModel)]="account.email"
                required
                emailValidator
            />
            <mat-error *ngIf="email.invalid">{{ email.errors | formErrors }}</mat-error>
        </mat-form-field>

        <ng-container>
            <ui-date-picker
                [label]="'self-serve.addYourTeam.addEmployees.hireDate' | translate"
                [(ngModel)]="employee.hiredAt"
                [required]="true"
                #hiredAt="ngModel"
                name="hiredAt"
            >
            </ui-date-picker>

            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'self-serve.addYourTeam.addEmployees.office' | translate }}</mat-label>
                <mat-select
                    required
                    name="employeeOffice"
                    #employeeOffice="ngModel"
                    [(ngModel)]="employee.officeId"
                    [placeholder]="'self-serve.addYourTeam.addEmployees.selectAnOption' | translate"
                >
                    <mat-option *ngFor="let office of offices" [value]="office.id">{{ office.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.submitted && employeeOffice.invalid">{{
                    'self-serve.fieldRequired' | translate
                }}</mat-error>
            </mat-form-field>
        </ng-container>
    </div>

    <label id="is-sin-required">{{ 'self-serve.addYourTeam.addEmployees.isSinRequired' | translate }}</label>
    <mat-radio-group
        required
        class="vertical"
        aria-labelledby="is-sin-required"
        name="is-sin-required"
        #isSinRequired="ngModel"
        [(ngModel)]="employee.isSinRequired"
    >
        <mat-radio-button [value]="true">{{ 'yes' | translate }}</mat-radio-button>
        <mat-radio-button [value]="false">{{ 'no' | translate }}</mat-radio-button>

        <mat-error *ngIf="form.submitted && isSinRequired.invalid">{{
            'self-serve.fieldRequired' | translate
        }}</mat-error>
    </mat-radio-group>

    <app-segment-header title="self-serve.addYourTeam.addEmployees.compensation"></app-segment-header>
    <div class="responsive-grid">
        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{
                'self-serve.addYourTeam.addEmployees.salaryFrequency' | translate
            }}</mat-label>
            <mat-select name="salaryFrequency" required #salaryFrequency="ngModel" [(ngModel)]="salary.frequency">
                <mat-option *ngFor="let frequency of ['year', 'hour']" [value]="frequency">{{
                    'self-serve.' + frequency | translate
                }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ salary.frequencyLabel | translate }}</mat-label>
            <input
                type="text"
                matInput
                [ngModel]="salary.rate"
                (ngModelChange)="salary.rate = stripNonNumeric($event); resetCursorPosition()"
                [textMask]="{ mask: currencyMask }"
                [min]="0"
                name="salary"
                #salaryRate="ngModel"
                required
                [placeholder]="
                    'self-serve.addYourTeam.addEmployees.egAmount'
                        | translate: { amount: salary.frequency === 'hour' ? 30 : 45000 }
                "
            />

            <mat-error *ngIf="salaryRate.invalid">{{ firstName.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{
                'self-serve.addYourTeam.addEmployees.employmentType' | translate
            }}</mat-label>
            <mat-select
                required
                #employmentType="ngModel"
                name="employmentType"
                placeholder="{{ 'self-serve.addYourTeam.addEmployees.selectAnEmploymentType' | translate }}"
                [(ngModel)]="employee.employmentType"
            >
                <mat-option *ngFor="let employmentType of employmentTypeValues" [value]="employmentType">{{
                    employmentTypeDisplay[employmentType] | translate | capitalize
                }}</mat-option>
            </mat-select>

            <mat-error *ngIf="employmentType.invalid">{{ employmentType.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'self-serve.addYourTeam.addEmployees.hoursPerWeek' | translate }}</mat-label>
            <input
                type="number"
                [min]="0"
                [max]="168"
                placeholder="{{ 'self-serve.addYourTeam.addEmployees.eg40' | translate }}"
                name="hoursPerWeek"
                required
                #hoursPerWeek="ngModel"
                matInput
                [(ngModel)]="salary.hoursPerWeek"
            />

            <mat-error *ngIf="hoursPerWeek.invalid">{{ hoursPerWeek.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <app-segment-header title="self-serve.addYourTeam.addEmployees.employeeRole"></app-segment-header>
    <div class="responsive-grid">
        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{ 'forms.applicant-tracker.hire-flow.department' | appTranslate }}</mat-label>
            <mat-select
                placeholder="{{ 'forms.applicant-tracker.hire-flow.selectADepartment' | appTranslate }}"
                required
                [(ngModel)]="employee.department"
                #department="ngModel"
                [compareWith]="isSameModel"
                name="department"
            >
                <mat-option (click)="showCreateDepartmentModal = true"
                    ><span class="add-option">{{
                        'forms.applicant-tracker.hire-flow.addNewDepartment' | appTranslate
                    }}</span></mat-option
                >
                <mat-option *ngFor="let department of departments" [value]="department">{{
                    department.name
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="department.invalid">{{ department.errors | formErrors }}</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{ 'forms.applicant-tracker.hire-flow.position' | appTranslate }}</mat-label>
            <mat-select
                placeholder="{{ 'forms.applicant-tracker.hire-flow.selectAPosition' | appTranslate }}"
                required
                [(ngModel)]="employee.job"
                #position="ngModel"
                [compareWith]="isSameModel"
                name="position"
            >
                <mat-option (click)="showCreateJobModal = true"
                    ><span class="add-option">{{
                        'forms.applicant-tracker.hire-flow.addNewPosition' | appTranslate
                    }}</span></mat-option
                >
                <mat-option *ngFor="let position of jobs" [value]="position">{{ position.title }}</mat-option>
            </mat-select>
            <mat-error *ngIf="position.invalid">{{ position.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'forms.applicant-tracker.hire-flow.reportsTo' | appTranslate }}</mat-label>
            <ui-employee-autocomplete
                name="reportsTo"
                #reportsTo="ngModel"
                [(ngModel)]="employee.manager"
                [allowNone]="true"
            ></ui-employee-autocomplete>
        </mat-form-field>
    </div>

    <div class="flex buttons justify-end">
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{ 'save' | translate }}</ui-button>
    </div>
</form>

<ui-dialog
    [open]="showCreateJobModal"
    [form]="positionForm"
    size="small"
    (primaryButtonPressed)="onCreatePosition(newJob)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="clearPosition()"
    (closing)="clearPosition()"
    secondaryButtonLabel="cancel"
    header="{{ 'applicant-tracker.createNewPosition' | appTranslate }}"
>
    <form #positionForm="ngForm">
        <app-position-form *ngIf="showCreateJobModal" [position]="newJob"></app-position-form>
    </form>
</ui-dialog>

<ui-dialog
    [open]="showCreateDepartmentModal"
    [form]="departmentForm"
    size="small"
    (primaryButtonPressed)="onCreateDepartment(newDepartment)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="clearDepartment()"
    (closing)="clearDepartment()"
    secondaryButtonLabel="cancel"
    header="{{ 'applicant-tracker.createNewDepartment' | appTranslate }}"
>
    <form #departmentForm="ngForm">
        <app-department-form *ngIf="showCreateDepartmentModal" [department]="newDepartment"></app-department-form>
    </form>
</ui-dialog>
